import { Component, OnInit, Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";

@Component({
  selector: "app-remuneration-dialog",
  templateUrl: "./remuneration-dialog.component.html",
  styleUrls: ["./remuneration-dialog.component.scss"],
})
export class RemunerationDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<RemunerationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const remunerationResponse = data;
  }

  ngOnInit() {}

  public viewURL() {}
}
